import React, { useEffect, useState } from "react";
import { Nav, Tab, Spinner, Navbar, Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Cookies from "js-cookie";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";

import { useColors } from "../../contexts/ColorContext";

import {
  Clock,
  PlusCircle,
  CalendarCheck,
  Gear,
  BoxArrowRight,
  CurrencyDollar,
  Speedometer
} from "react-bootstrap-icons";

import DashboardFuncionario from "./funcionario/DashboardFuncionario";
import Agenda from "./funcionario/Agenda";
import Horarios from "./funcionario/Horarios";
import NovoAgendamento from "./funcionario/NovoAgendamento";
import VendaProdutos from "./funcionario/VendaProdutos";
import Configuracoes from "./funcionario/Configuracoes";

export default function Sistema() {
  const navigate = useNavigate();
  const { colors, updateColors } = useColors();
  const {
    primaryColor,
    secondaryColor,
    bgColor,
    textColor,
    textColorLight,
    sidebarColor,
    buttonColor,
    btnTextColor
  } = colors;

  const [usuario, setUsuario] = useState(null);
  const [idClienteMaster, setIdClienteMaster] = useState(null);
  const [activeKey, setActiveKey] = useState("dashboard");
  const [loading, setLoading] = useState(true);
const [expanded, setExpanded] = useState(false);

  // Carrega usuário
  useEffect(() => {
    const raw = Cookies.get("usuario");
    if (!raw) {
      navigate("/login");
      return;
    }

    const storedUser = JSON.parse(raw);
    setUsuario(storedUser);

    if (storedUser.role === "Funcionario") {
      fetchFuncionarioData(storedUser.id, storedUser.celular);
      return;
    }
  }, [navigate]);

  const fetchFuncionarioData = async (funcionarioId, celular) => {
    try {
      const response = await api.get(`/Funcionarios/${funcionarioId}`);
      const masterId = response.data.clienteMasterId;
      setIdClienteMaster(masterId);

      // Carregar cores do administrador
      try {
        const coresResponse = await api.get(`/ConfiguracaoCores/${masterId}`);
        if (coresResponse.data) {
          updateColors(coresResponse.data);
        }
      } catch (error) {
        console.warn("Não foi possível carregar as cores do administrador:", error);
      }

    } catch (error) {
      console.error("Erro ao buscar funcionário:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    Cookies.remove("usuario");
    navigate("/login");
  };

  // TELA DE CARREGAMENTO TEMATIZADA CORRETAMENTE
  if (loading) {
    return (
      <div
        style={{
          backgroundColor: bgColor,
          color: textColor,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Spinner animation="border" />
      </div>
    );
  }

  if (!usuario) {
    return (
      <div className="text-center mt-5" style={{ color: textColor }}>
        <p>Carregando informações...</p>
      </div>
    );
  }

  // ESTILOS 100% TEMATIZADOS
 const styles = {
    sidebar: {
      backgroundColor: sidebarColor,
      color: textColor,
      minHeight: "100vh",
      paddingTop: "20px",
      boxShadow: "2px 0 5px rgba(0,0,0,0.5)"
    },
    navLink: {
      color: textColor,
    padding: "10px 15px",
    borderRadius: "8px",
    margin: "5px 0",
    display: "flex",
    alignItems: "center",
    cursor: "pointer"
    },
   navLinkActive: {
  backgroundColor: primaryColor,
  color: btnTextColor, 
  fontWeight: "bold",
  boxShadow: `0 2px 4px ${primaryColor}55`,
  border: `1px solid ${primaryColor}`
},
    contentArea: {
      backgroundColor: bgColor,
      minHeight: "100vh",
      padding: "30px",
      color: textColor
    },
    header: {
      marginBottom: "30px",
      borderBottom: `1px solid ${sidebarColor}`,
      paddingBottom: "15px"
    }
  };

  const navItems = [
    { key: "dashboard", title: "Dashboard", icon: <Speedometer size={18} /> },
    { key: "agenda", title: "Minha Agenda", icon: <CalendarCheck size={18} /> },
    { key: "horarios", title: "Horários / Bloqueios", icon: <Clock size={18} /> },
    { key: "novo", title: "Novo Agendamento", icon: <PlusCircle size={18} /> },
    { key: "venda", title: "Venda de Produtos", icon: <CurrencyDollar size={18} /> },
    { key: "config", title: "Configurações", icon: <Gear size={18} /> }
  ];

  return (
    <>
      <div className="d-flex" style={{ minHeight: "100vh", overflowX: "hidden" }}>
        
        {/* SIDEBAR */}
        <div style={styles.sidebar} className="col-lg-2 col-md-3 d-none d-md-block">
          
          <h4 className="text-center mb-4" style={{ color: primaryColor }}>
            Funcionário
          </h4>

          <p className="text-center text-muted small" style={{ color: textColorLight }}>
            Bem-vindo, {usuario.nome}!

          </p>

<Nav
  variant="pills"
  className="flex-column px-3"
  activeKey={activeKey}   
>            {navItems.map(item => (
              <Nav.Item key={item.key}>
                <Nav.Link
                  eventKey={item.key}
                  onClick={() => setActiveKey(item.key)}
                  style={
                    activeKey === item.key
                      ? styles.navLinkActive
                      : styles.navLink
                  }
                >
                  <span className="me-2">{item.icon}</span>
                  {item.title}
                </Nav.Link>
              </Nav.Item>
            ))}

            <Nav.Item className="mt-4">
              <Nav.Link
                onClick={handleLogout}
                style={{ ...styles.navLink, color: "#dc3545" }}
              >
                <BoxArrowRight className="me-2" size={18} />
                Sair
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>

        <div className="flex-grow-1 col-12 col-md-10 col-lg-10" style={styles.contentArea}>
          
          {/* NAVBAR MOBILE */}
<Navbar
  expand="md"
  variant="dark"
  expanded={expanded}
  onToggle={(val) => setExpanded(val)}
  style={{ backgroundColor: secondaryColor }}
  className="d-md-none mb-3 rounded"
>
  <Container fluid>
    <Navbar.Brand style={{ color: primaryColor }}>
      Funcionário
    </Navbar.Brand>

    <Navbar.Toggle />

    <Navbar.Collapse>
      <Nav className="me-auto">
        {navItems.map(item => (
          <Nav.Link
            key={`mobile-${item.key}`}
            onClick={() => {
              setActiveKey(item.key);
              setExpanded(false);   // FECHA O MENU AO CLICAR
            }}
            style={
              activeKey === item.key
                ? styles.navLinkActive
                : styles.navLink
            }
          >
            <span className="me-2">{item.icon}</span>
            {item.title}
          </Nav.Link>
        ))}

        <Nav.Link
          onClick={() => {
            handleLogout();
            setExpanded(false);   // FECHA O MENU AO SAIR
          }}
          style={{ ...styles.navLink, color: "#dc3545" }}
        >
          <BoxArrowRight className="me-2" size={18} /> Sair 
        </Nav.Link>
      </Nav>
    </Navbar.Collapse>
  </Container>
</Navbar>


          <div style={styles.header}>
            <h1>Painel do Funcionário</h1>
            <p className="text-muted">Gerencie sua agenda, horários e perfil.</p>
          </div>

          <Tab.Container activeKey={activeKey}>
            <Tab.Content>
              <Tab.Pane eventKey="dashboard">
                <DashboardFuncionario usuario={usuario} idClienteMaster={idClienteMaster} />
              </Tab.Pane>

              <Tab.Pane eventKey="agenda">
                <Agenda usuario={usuario} idClienteMaster={idClienteMaster} />
              </Tab.Pane>

              <Tab.Pane eventKey="horarios">
                <Horarios usuario={usuario} idClienteMaster={idClienteMaster} />
              </Tab.Pane>

              <Tab.Pane eventKey="novo">
                <NovoAgendamento usuario={usuario} idClienteMaster={idClienteMaster} />
              </Tab.Pane>

              <Tab.Pane eventKey="venda">
                <VendaProdutos usuario={usuario} idClienteMaster={idClienteMaster} />
              </Tab.Pane>

              <Tab.Pane eventKey="config">
                <Configuracoes usuario={usuario} />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
    </>
  );
}
